export default "__VITE_ASSET__DyJGisqt__"